import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/Weasis.png'


const _hoisted_1 = { class: "container-fluid text-start border-bottom" }
const _hoisted_2 = {
  href: "https://github.com/nroduit/Weasis/releases/download/v4.5.1/Weasis-4.5.1-x86-64.msi",
  target: "_blank",
  rel: "noopener noreferrer",
  style: {"font-size":"0.8em"},
  class: "highlight"
}
const _hoisted_3 = { class: "container-fluid mt-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = { class: "list-group" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = { class: "row vl-parent" }
const _hoisted_10 = {
  key: 0,
  class: "container py-5 my-5"
}
const _hoisted_11 = {
  class: "card position-relative",
  style: {"background-color":"#eeeeee"}
}
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "text-start mt-2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "card-title fw-semibold" }
const _hoisted_21 = {
  key: 1,
  class: "card-footer px-0"
}
const _hoisted_22 = { class: "d-flex justify-content-between w-100" }
const _hoisted_23 = {
  key: 0,
  class: "btn btn-danger mx-auto btn-custom btn-danger bg-danger w-auto",
  disabled: ""
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.t('download_viewer')) + " ", 1),
        _cache[1] || (_cache[1] = _createElementVNode("i", {
          class: "fa-fw fas fa-download",
          style: {"font-size":"0.8em"}
        }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceStore.devices, (device) => {
              return (_openBlock(), _createElementBlock("li", {
                key: device.id,
                onClick: ($event: any) => (_ctx.selectDevice(device)),
                class: _normalizeClass([
              'list-group-item',
              { active: device.id === _ctx.selectedDevice?.id }
            ]),
                style: {"cursor":"pointer"}
              }, _toDisplayString(device.name), 11, _hoisted_7))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_loading, {
              active: _ctx.isLoading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
              "can-cancel": false,
              loader: "dots",
              opacity: 0.6,
              "is-full-page": false
            }, null, 8, ["active"]),
            (_ctx.studyStore.studies.length === 0 && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.t('no_dicom_files')), 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.studyStore.studies, (study) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: study.id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(study.storedFiles, (file) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-3 col-xl-2 mb-4",
                        key: file.fileName
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_Popper, {
                            class: "info-icon",
                            content: "TEST",
                            hover: true,
                            placement: "right",
                            arrow: true,
                            "z-index": "99999999"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.t('study')) + ":", 1),
                                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                (study.studyDescription)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.t('study_description')) + ": " + _toDisplayString(study.studyDescription), 1))
                                  : _createCommentVNode("", true),
                                (study.studyDateTime !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.t('study_date')) + ": " + _toDisplayString(_ctx.getDateFormat(study.studyDateTime)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.t('patient')) + ":", 1),
                                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                (study?.patient?.patientName !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.t('patient_name')) + ": " + _toDisplayString(study.patient.patientName.replaceAll('^', ' ')), 1))
                                  : _createCommentVNode("", true),
                                (study?.patient?.patientID !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.t('patient_id')) + ": " + _toDisplayString(study.patient.patientID), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            default: _withCtx(() => [
                              _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                width: "20px",
                                height: "20px",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("g", {
                                  id: "SVGRepo_bgCarrier",
                                  "stroke-width": "0"
                                }),
                                _createElementVNode("g", {
                                  id: "SVGRepo_tracerCarrier",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                  _createElementVNode("path", {
                                    d: "M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z",
                                    fill: "#1C274C"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z",
                                    fill: "#1C274C"
                                  }),
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z",
                                    fill: "#1C274C"
                                  })
                                ])
                              ], -1))
                            ]),
                            _: 2
                          }, 1024),
                          (
                    file.altrisExamination?.status === 'UPLOAD_ERROR' ||
                    file.altrisExamination?.status === 'PDF_ERROR'
                  )
                            ? (_openBlock(), _createBlock(_component_Popper, {
                                key: 0,
                                class: "info-icon-error",
                                hover: true,
                                placement: "right",
                                arrow: true,
                                "z-index": "99999999"
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("p", null, _toDisplayString(file.altrisExamination?.errorMessage), 1)
                                ]),
                                default: _withCtx(() => [
                                  _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                    width: "20px",
                                    height: "20px",
                                    viewBox: "-2.4 -2.4 28.80 28.80",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    transform: "matrix(1, 0, 0, 1, 0, 0)"
                                  }, [
                                    _createElementVNode("g", {
                                      id: "SVGRepo_bgCarrier",
                                      "stroke-width": "0"
                                    }),
                                    _createElementVNode("g", {
                                      id: "SVGRepo_tracerCarrier",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      stroke: "#CCCCCC",
                                      "stroke-width": "1.7759999999999998"
                                    }),
                                    _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                      _createElementVNode("path", {
                                        d: "M12 8V12",
                                        stroke: "#f90b0b",
                                        "stroke-width": "2.4",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }),
                                      _createElementVNode("path", {
                                        d: "M12 16.0195V16",
                                        stroke: "#f90b0b",
                                        "stroke-width": "2.4",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }),
                                      _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "#f90b0b",
                                        "stroke-width": "2.4",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      })
                                    ])
                                  ], -1))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            src: _imports_0,
                            class: "card-img-top mx-auto mt-4 cursor",
                            alt: "DICOM file",
                            style: {"width":"80px"},
                            onClick: ($event: any) => (_ctx.openDicomFile(file.id))
                          }, null, 8, _hoisted_18),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.getDateFormat(study?.studyDateTime)), 1)
                          ]),
                          (file.isEligibleForAltris)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  (file.altrisExamination?.status === 'PENDING')
                                    ? (_openBlock(), _createElementBlock("button", _hoisted_23, [
                                        _cache[6] || (_cache[6] = _createElementVNode("span", {
                                          class: "spinner-grow spinner-grow-sm",
                                          role: "status",
                                          "aria-hidden": "true"
                                        }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.t('in_processing')), 1)
                                      ]))
                                    : (file.altrisExamination?.status === 'SUCCESS')
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "btn btn-danger btn-custom mx-auto",
                                          style: {"background-color":"#23408e"},
                                          onClick: ($event: any) => (_ctx.getAltrisPdf(file.id))
                                        }, _toDisplayString(_ctx.t('pdf_ai')), 9, _hoisted_24))
                                      : (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          class: "btn btn-danger btn-custom mx-auto",
                                          style: {"background-color":"#23408e"},
                                          onClick: ($event: any) => (_ctx.uploadDicomToAltris(file.id))
                                        }, _toDisplayString(_ctx.t('ai_analysis')), 9, _hoisted_25))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ], 64))
                }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}